import React from 'react';

import GlobalContextProvider from './src/context/GlobalContextProvider';
import './src/styles/index.scss';

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};

export const disableCorePrefetching = () => true;
